import React from 'react';
import '../css/Vision.css'; 
import { Container, Row, Col, Button } from 'react-bootstrap'; // Import Bootstrap components

const Vision = () => {
  return (
    <section className="vision-section">
      <Container>
        <h2 className="vision-title pt-4">Our Vision & Mission</h2>
        
        <Row>
          <Col xs={12} md={6} className="vision-content">
            <h3 className="vision-header">Vision</h3>
            <p className="vision-description">
              At <strong className='text-white'>SHREE Tours & Travels</strong>, our vision is to revolutionize the travel experience by offering safe, comfortable and memorable journeys. We aim to connect people with the world in a way that prioritizes comfort, convenience and sustainability. Through innovation and dedication, we seek to provide exceptional travel experiences that go beyond expectations, while maintaining a strong commitment to eco-friendly practices. Our vision is to make travel accessible, enjoyable and impactful for every traveler.
            </p>
          </Col>

          <Col xs={12} md={6} className="mission-content">
            <h3 className="mission-header">Mission</h3>
            <p className="mission-description">
              Our mission at <strong className='text-white'>SHREE Tours & Travels</strong> is to deliver exceptional and reliable travel services that meet the diverse needs of our customers. We are committed to ensure every journey is comfortable, safe and enjoyable by maintaining high standards of service, skilled drivers and well-maintained vehicles. By continuously listening to our customers and improving our services, we aim to build lasting relationships and provide an experience that exceeds expectations every time.
            </p>
          </Col>
        </Row>

      </Container>
    </section>
  );
};

export default Vision;
